import { render, staticRenderFns } from "./TriagePage.vue?vue&type=template&id=748d7fd8&"
import script from "./TriagePage.vue?vue&type=script&lang=js&"
export * from "./TriagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports